"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = _interopRequireDefault(require("lodash/fp/map"));

var _Tree = require("./Tree");

var _TreeLeaf = _interopRequireDefault(require("./TreeLeaf"));

var TreeLeafList = function TreeLeafList(props) {
  var leafList = props.leafList,
      hasMultiselect = props.hasMultiselect,
      showRadioButtons = props.showRadioButtons,
      selectedItems = props.selectedItems,
      selectedGroups = props.selectedGroups,
      onSelectionChange = props.onSelectionChange;

  var handleItemSelection = function handleItemSelection(itemId) {
    var isSelected = selectedItems.includes(itemId);
    var newSelectedItems = isSelected ? (0, _Tree.excludeFromList)(selectedItems, itemId) : [].concat((0, _toConsumableArray2.default)(selectedItems), [itemId]);
    onSelectionChange(newSelectedItems, selectedGroups);
  };

  var handleSetItemActive = function handleSetItemActive(itemId) {
    return onSelectionChange([itemId], []);
  };

  return (0, _map.default)(function (item) {
    return /*#__PURE__*/_react.default.createElement(_TreeLeaf.default, {
      key: item.id,
      item: item,
      hasMultiselect: hasMultiselect,
      showRadioButtons: showRadioButtons,
      isSelected: selectedItems.includes(item.id),
      onSelectItem: function onSelectItem() {
        return handleItemSelection(item.id);
      },
      onActiveItem: function onActiveItem() {
        return handleSetItemActive(item.id);
      }
    });
  })(leafList);
};

TreeLeafList.displayName = 'TreeLeafList';
TreeLeafList.propTypes = {
  leafList: _propTypes.default.arrayOf(_propTypes.default.object),
  hasMultiselect: _propTypes.default.bool,
  showRadioButtons: _propTypes.default.bool,
  selectedItems: _propTypes.default.arrayOf(_propTypes.default.string),
  selectedGroups: _propTypes.default.arrayOf(_propTypes.default.string),
  onSelectionChange: _propTypes.default.func
};
var _default = TreeLeafList;
exports.default = _default;